import styled from 'styled-components';

export const HelpText = styled.div`
  font-size: 0.8em;
  background: #4265e9;
  color: #fff;
  padding: 1em;
  margin-bottom: 1em;
`;
